import { Module } from '@/modules/companies/consts'
import type {
  AllDynamicColumnsQuery,
  AllDynamicColumnsQueryVariables,
} from '@/modules/dynamic_tables'
import { ALL_DYNAMIC_COLUMNS_QUERY } from '@/modules/dynamic_tables'
import { useOnErrorAuto } from '@/utils/hooks'
import { useQuery } from '@apollo/client'
import { useMemo } from 'react'
import { buildVehicleColumnConfig } from './columns'
import type { VehicleColumnConfig } from './columns'
import type { VehicleTable } from './consts'

/**
 * The company's column configuration for one vehicle list.
 *
 * The three lists are shown twice each -- fleet-wide and on the vehicle -- and
 * both places resolve their columns through this, so a change made in settings
 * reaches the two of them at once.
 */
export function useVehicleTableColumns(table: VehicleTable): {
  loading: boolean
  config: VehicleColumnConfig
} {
  const onErrorAuto = useOnErrorAuto()

  const { data, loading } = useQuery<
    AllDynamicColumnsQuery,
    AllDynamicColumnsQueryVariables
  >(ALL_DYNAMIC_COLUMNS_QUERY, {
    variables: { moduleName: Module.VEHICLES, table },
    fetchPolicy: 'cache-first',
    onError: onErrorAuto(),
  })

  const config = useMemo(
    () => buildVehicleColumnConfig(data?.allDynamicColumns.edges ?? []),
    [data]
  )

  return { loading, config }
}
